import { ENV } from "./env";

/**
 * Enum for microservice names (type-safe, autocomplete-friendly)
 */
export enum Microservice {
  DOCUMENT_MANAGEMENT = "document-management",
  NOTIFICATIONS = "notifications",
  OMS = "oms",
  PAYMENT = "payment",
  SKU_FINANCE = "sku-finance",
  TRADE_DIRECTORY = "trade-directory",
  WMS = "wms",
}

/**
 * Microservice port mapping for local development
 */
const MICROSERVICE_PORTS: Record<Microservice, number> = {
  [Microservice.TRADE_DIRECTORY]: 3001,
  [Microservice.NOTIFICATIONS]: 3004,
  [Microservice.DOCUMENT_MANAGEMENT]: 3005,
  [Microservice.SKU_FINANCE]: 3006,
  [Microservice.PAYMENT]: 3008,
  [Microservice.WMS]: 3009,
  [Microservice.OMS]: 3010,
};

const BASE_URL_CONFIG = {
  local: "http://localhost", // Will append :PORT per microservice
  dev: "https://api-newdev.fundedhere.com",
  uat: "https://api-uat.fundedhere.com",
  production: "https://api.fundedhere.com",
} as const;

/**
 * Gets base URL for a microservice based on environment
 *
 * @param microservice - The microservice to get URL for
 * @returns Base URL for the microservice
 *
 * @example
 * getBaseUrl(Microservice.SKU_FINANCE)
 * // Returns: "http://localhost:3006" (if ENV="local")
 * // Returns: "https://api-newdev.fundedhere.com" (if ENV="dev")
 * // Returns: "https://api-uat.fundedhere.com" (if ENV="uat")
 * // Returns: "https://api.fundedhere.com" (if ENV="production")
 */
export function getBaseUrl(microservice: Microservice): string {
  // For local development, use localhost with microservice-specific port
  if (ENV === "local") {
    const port = MICROSERVICE_PORTS[microservice];
    return `http://localhost:${port}`;
  }

  // For UAT and production, use unified gateway
  return BASE_URL_CONFIG[ENV];
}
